<iframe *ngIf="safeSrc" 
        [ngStyle]="{'height': '413px', 'z-index':1000, 'display': 'block'}" 
        class="w-100" 
        [src]="safeSrc"
        frameborder="0" 
        allowfullscreen>
</iframe>